import { render, staticRenderFns } from "./FormGoods.vue?vue&type=template&id=66ef6a0d&scoped=true"
import script from "./FormGoods.vue?vue&type=script&lang=js"
export * from "./FormGoods.vue?vue&type=script&lang=js"
import style0 from "./FormGoods.vue?vue&type=style&index=0&id=66ef6a0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef6a0d",
  null
  
)

export default component.exports